module.exports = __webpack_public_path__ + "img/obch4.36745f1e.svg";